var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_510_3093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57556 0.229323L8.91389 8.55152C9.32815 9.02496 9.93474 9.29867 10.5635 9.29867C11.1923 9.29867 11.7989 9.02496 12.2132 8.55152L19.4184 0.369875C19.4775 0.303298 19.5515 0.251515 19.6255 0.20713C19.3222 0.0739751 18.9819 0 18.6268 0H2.49285C2.15257 0 1.82708 0.0665776 1.53857 0.192335C1.55337 0.20713 1.56816 0.214528 1.57556 0.229323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7352 1.1687C20.7056 1.25007 20.6612 1.33145 20.5947 1.40542L13.3821 9.58706C12.6645 10.4008 11.6363 10.8594 10.5562 10.8594C9.47621 10.8594 8.44795 10.3934 7.7304 9.58706L0.399465 1.26487C0.399465 1.26487 0.377273 1.22788 0.362478 1.21309C0.133155 1.59036 0 2.02681 0 2.50025V13.7741C0 15.15 1.11702 16.267 2.49296 16.267H18.6269C20.0029 16.267 21.1199 15.15 21.1199 13.7741V2.49285C21.1199 2.00462 20.9793 1.55337 20.7352 1.1687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_3093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1199,
    height: 16.2523,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhite);
export default __webpack_public_path__ + "static/media/mail-white.966604cbf6336fa218d5ab7dc84d35db.svg";
export { ForwardRef as ReactComponent };